import axios from './axios-instance'

export default {
  subscribe (payload) {
    return axios.post('v1/subscribe', payload)
  }
}
